import {combineReducers} from 'redux';
import posts from './posts';
import post from './post';
import datepicker from './datepicker';
import search from './search';
import subscribe from './subscribe';
import user from './user';
import experiments from './experiments';
import locale from './locale';

export default combineReducers({
  posts,
  post,
  search,
  datepicker,
  subscribe,
  user,
  locale,
  experiments
});



// WEBPACK FOOTER //
// ./reducers/index.js